import { Switch, Upload, Typography, Modal, Row, Col, Button, DatePicker, Radio, Card, Input, Popconfirm, Checkbox, Empty } from 'antd';
import React, { useEffect, Suspense, useState } from 'react';
import FileViewer from "react-file-viewer";
import axios from 'axios';
import { DownloadOutlined, } from '@ant-design/icons';
import EditorSpreadsheet from '../../../controls/EditorSpreadsheet';
// import { Presentation, Slide, Text, Shape, Image, render } from "react-pptx";
const PreviewModal = (props) => {
    const [switchMode, setSwitchMode] = useState(false);

    const handleDownload = () => {
        // console.log(props.file);
        // console.log(props.file.file_id);
        axios
            .get('/cramSchool/api/media/classify_structure_type_file_download', {
                responseType: 'blob',
                params: {
                    file_id: props.file.file_id
                }
            })
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `${props.file.file_client_name}`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
    }
    const handleOnChange = (checked) => {
        // console.log(checked);
        setSwitchMode(checked)
    }
    useEffect(() => {
        setSwitchMode(false);
    }, [props.file])
    return (
        <Modal
            open={props.open}
            // onOk={hideModal}
            onCancel={e => props.setOpen(false)}
            footer={false}
            width={1000}
            style={{ padding: '20px' }}
            centered
        >
            <Row justify={'end'} style={{ paddingRight: '20px' }} gutter={[8, 16]}>
                <Col>
                    <Switch checkedChildren="編輯" unCheckedChildren="預覽" defaultChecked={false} onChange={handleOnChange} />
                </Col>
                {/* <Col style={{ paddingRight: '40px', paddingTop: '10px' }}>
                    <Button type='primary' style={{ display: "inline-flex", alignItems: "center" }} icon={<DownloadOutlined />}
                        // onClick={e => window.open(`${axios.defaults.baseURL}/cramSchool/api/media/classify_structure_type_file_download?file_id=${props.file_id}`)}
                        onClick={handleDownload}
                    >檔案下載</Button>
                </Col> */}
                {switchMode ? <>

                    <Col span={24} style={{ overflowX: 'scroll' }}>
                        <EditorSpreadsheet
                            mode={'edit'}
                            file_id={props.file?.file_id}
                            file={props.file} 
                            setOpen={props.setOpen}/>
                    </Col>
                </> : <>
                    <Col span={24} style={{ overflowX: 'scroll' }}>
                        <EditorSpreadsheet
                            mode={'read'}
                            file_id={props.file?.file_id}
                            file={props.file} />
                    </Col>
                </>}
            </Row>
        </Modal >
    )
}
export default PreviewModal;